import { get } from '@webapp-next/lib/request/webapp/apiv2';
import { WebappApiResponse } from '@/lib/types/request/request';
import { Workplace } from '@/modules/people/types/people-setup';

export type PayCentresGetResponse = WebappApiResponse<Workplace[]>;

export default async function payCentresGet(
  offset = 0
): Promise<PayCentresGetResponse> {
  try {
    const { data } = await get<
      PayCentresGetResponse,
      WebappApiResponse<{ companies: Workplace[] }>
    >('/api/v2/people/companies', {
      // TODO: Axios Get doesnt accept any body, verify this implementation
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      sort: { Id: 'asc' },
      search: {
        IsActive: {
          field: 'Active',
          type: 'eq',
          data: 1,
        },
        IsPayCentre: {
          field: 'IsPayrollEntity',
          type: 'eq',
          data: 1,
        },
      },
      max: 500,
      start: offset,
    });

    return {
      success: true,
      // TODO: we need to move this processing outside of API request layer
      data: data.companies.filter(
        company => company.IsPayrollEntity && company.Active
      ),
      message: '',
      headers: {},
      meta: {},
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
